import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AceAuthService } from '../services/auth/ace-auth.service';

@Injectable()
export class AceTokenInterceptor implements HttpInterceptor {
  constructor(private aceAuthService: AceAuthService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!this.shouldAttach(req)) {
      return next.handle(req);
    }
    return this.aceAuthService.getToken().pipe(
      switchMap(token =>
        next.handle(this.withToken(req, token)).pipe(
          catchError((err: unknown) => {
            if (err instanceof HttpErrorResponse && err.status === 401) {
              this.aceAuthService.clear();
              return this.aceAuthService
                .getToken()
                .pipe(switchMap(freshToken => next.handle(this.withToken(req, freshToken))));
            }
            return throwError(() => err);
          })
        )
      )
    );
  }

  private shouldAttach(req: HttpRequest<unknown>): boolean {
    const base = environment.teamApiUrl;
    if (!base || !req.url.startsWith(base)) {
      return false;
    }
    return (
      !req.url.includes('auth/keycloak/exchange') &&
      !req.url.includes('auth/refresh')
    );
  }

  private withToken(
    req: HttpRequest<unknown>,
    token: string
  ): HttpRequest<unknown> {
    return req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  }
}
